// src/components/MenuRedirect.js
import { useParams, Navigate } from 'react-router-dom';
import CustomerMenuInterface from './CustomerMenuInterface';
import { LanguageProvider } from '../contexts/LanguageContext';

const MenuRedirect = () => {
  const { restaurantId } = useParams();

  // Hatalı GUID kontrolü
  if (restaurantId.toLowerCase() === '7a3306ac3-9c62-4027-9be3-c67f3d06dc6e') {
    return <Navigate to="/menu/a3306ac3-9c62-4027-9be3-c67f3d06dc6e" replace />;
  }

  // Doğru GUID ise menü sayfasını dil sağlayıcı içinde göster
  return (
    <LanguageProvider restaurantId={restaurantId}>
      <CustomerMenuInterface />
    </LanguageProvider>
  );
};

export default MenuRedirect;